import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const UPSERT_WORKSPACE_AMAZON: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation upsertWorkspaceAmazon($input: UpsertWorkspaceAmazonInput!) {
    upsertWorkspaceAmazon(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
